<template>
  <b-container class="Sendinblue" id="Sendinblue">
    <b-row :class="{dn: $store.state.isOpen}">
      <b-col class="center" v-on:click="$store.state.isOpen = !$store.state.isOpen" cols="12">
          <div href="#contactFormDiv" class="discussBtn">{{ $t('discuss') }}<img src="../assets/discussIcon.png" alt="chat"></div>
      </b-col>
    </b-row>
    <b-row :class="{dn: !$store.state.isOpen}" class="pink_bg">
      <b-col cols="12">
        <div class="closeForm" v-on:click="$store.state.isOpen = !$store.state.isOpen">
            <p>X</p>
        </div>
        <p class="formMsg center">{{$t('brands.form.msg')}}</p>
      </b-col>
      <b-col cols="12">
        <iframe width="650" height="800" src="https://b6757cb1.sibforms.com/serve/MUIEAOSENbly1eIieKfEyw7gM47X4JGt83vTwJuM3Me7PdDnAsZl3QCEq_Oxko_Ca00gUtT7vSbbYwlK1aw7EaMPlRUESCJL93e1lCS1hg-EI6wGLEQUKQv4JKL-Be8a81T0jqA6kn8yRaIo_sjCkMdDJqtG_s89VJGgg5KMqr4FNFUa1vbN_51FTwInnXFOoozWIDfUibpalLHw" frameborder="0" scrolling="auto" allowfullscreen style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"></iframe>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Sendinblue',
  data() {
    return {
      isClose: 1
    }
  }
}
</script>

<style>
.closeForm {
  text-align: right;;
  margin-right: 20%;
  color: #FF2247;
  font-size: 20px;
  font-weight:bold;
}

.pink_bg {
  padding-top:60px;
  background-color: #FEFBFC;
}

.formMsg{
  color: #FF2247;
  font-size: 20px;
  font-weight:bold;
  letter-spacing: 1px;
}
</style>
